import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { injectIntl, IntlShape } from 'react-intl';

import { MRH_QUOTE_LINK } from 'constants/externalLinks';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import MyOfferLayout from 'components/MyOffers';
import messages from 'containers/AmcDetailsPage/MyOffers/messages';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { translate } from 'helpers/intl';

const MyOffers = (props: { intl: IntlShape }) => {
  const language = useSelector(getLocaleSelector);

  return (
    <MyOfferLayout
      title={translate(get(messages, 'title'), props)}
      subTitle={translate(get(messages, 'subTitle'), props)}
      body={translate(get(messages, 'body'), props)}
      actionPath={MRH_QUOTE_LINK[language]}
      actionLabel={translate(get(messages, 'action'), props)}
      image="house"
      gaLabel="Faire un devis MRH"
      category={EVENT_CATEGORIES.AMC_DETAILS}
    />
  );
};

export default injectIntl(MyOffers);
